// Trades per page on the /sending and /receiving tab lists
export const TRADES_PAGE_SIZE = 25;
